/**
 * Determine if the dataset contains any editable fields
 *
 * @param  {Object} state
 * @return {Boolean}
 */
const hasEditableFields = state => state.data.some(i => i.url)

export default {
    hasEditableFields
}



// WEBPACK FOOTER //
// ./src/state/modules/projects/single/net-proceeds/getters.js